/* unplugin-vue-components disabled */import script from "./CompanyArea.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyArea.vue?vue&type=script&setup=true&lang=js"

import "./CompanyArea.vue?vue&type=style&index=0&id=7379df46&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7379df46"]])

export default __exports__